<template>
  <Treeselect
    :options="filteredOptions"
    :placeholder="placeholder"
    :disableFuzzyMatching="true"
    :async="isAsync"
    :loadOptions="filterData"
    :value="value"
    :defaultOptions="defaultOptions"
    v-on="$listeners"
    v-bind="$attrs"
    v-if="reloadItems"
    :loading="loading"
    openDirection="bottom"
  />
</template>

<script>
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import ApiClient from '../utils/ApiClient';

export default {
  name: 'ComboBox',
  props: {
    value: [String, Number],
    placeholder: String,
    modelEndpoint: String,
    api: {
      type: String,
      default: 'root',
    },
    groupData: String,
    dataValueField: {
      type: String,
      default: 'id',
    },
    dataTextField: {
      type: String,
      default: 'label',
    },
    limitSearch: {
      type: Number,
      default: 3,
    },
  },
  components: {
    Treeselect,
  },
  data() {
    return {
      options: [],
      defaultOptions: [],
      isAsync: true,
      reloadItems: true,
      loading: false,
    };
  },
  mounted() {
    this.getOptions();
    if (!this.limitSearch) {
      this.isAsync = false;
    }
  },
  computed: {
    filteredOptions() {
      return !this.limitSearch ? this.options : [];
    },
  },
  methods: {
    filterData({ action, searchQuery, callback }) {
      if (this.limitSearch && searchQuery.length <= this.limitSearch) {
        return;
      }
      if (action === ASYNC_SEARCH) {
        const filterOptions = !this.limitSearch
          ? this.options
          : this.options.filter((x) => x.label.toLowerCase().includes(searchQuery.toLowerCase()));

        callback(null, filterOptions);
      }
    },
    getOptions() {
      const apiClient = new ApiClient(this.modelEndpoint, this.api);
      this.loading = true;
      apiClient.Get().then((data) => {
        const isEmpty = !this.value;
        this.loading = false;
        this.options = (!this.groupData ? data : data[this.groupData]).map((x) => {
          if (!isEmpty) {
            if (x[this.dataValueField] === this.value) {
              this.defaultOptions.push(x);
              this.reloadItems = false;
              this.$nextTick(() => {
                this.reloadItems = true;
              });
            }
          }
          return {
            id: x[this.dataValueField],
            label: x[this.dataTextField],
            item: x,
          };
        });
      });
    },
  },
};
</script>

<style lang="scss">
.vue-treeselect {
  font-family: 'Nunito Sans', sans-serif !important;
  &:focus {
    outline: 0 !important;
  }
  &__control {
    height: 31px;
    border: 1px solid #bdc6cc;
    border-radius: 3px !important;
    &:focus {
      outline: 0 !important;
    }
    &-arrow {
      color: #c2c2c2;
    }
  }
  &--focused {
    .vue-treeselect__control {
      border-color: #3471f9;
      &-arrow {
        color: #3471f9;
      }
    }
    .vue-treeselect__x {
      color: #3471f9;
    }
  }
}
.vue-treeselect--open-below .vue-treeselect__menu {
  margin-top: 0px !important;
}
.vue-treeselect__label {
  color: #333;
  font-size: 14px;
  line-height: 1.36;
  padding: 7px 8px;
}

.vue-treeselect__checkbox-container {
  padding-top: 10px !important;
}
.vue-treeselect__option--highlight {
  background-color: #ebf0f3;
}
.vue-treeselect__menu {
  border-color: #bdc6cc;
  border-radius: 3px !important;
}

.vue-treeselect__value-container {
  height: 31px;
}

.vue-treeselect--disabled .vue-treeselect__control {
  background-color: #e9ecef;
  cursor: not-allowed;
}
</style>
